import { Link } from "react-router";
import { buttonVariants } from "./ui/button";
import { cn, formatPhoneNumberForTelLink } from "#app/utils/misc.tsx";
import { Icon } from "./ui/icon";
import { useGtm } from "#app/utils/gtm-context.tsx";


export function MobileStickyButton({ phoneNumber }: { phoneNumber?: string | null }) {
    const formatNumber = formatPhoneNumberForTelLink(phoneNumber)
    const { trackEvent } = useGtm();

    const handlePhoneClick = () => {
        trackEvent('click_to_call', {
            link_text: phoneNumber || '',
            link_url: formatNumber,
            page_path: window.location.pathname + window.location.search,
            page_title: document.title,
        });
    };

    if (formatNumber) {
        return (
            <Link
                to={formatNumber}
                className={cn(
                    buttonVariants({ variant: "accent" }),
                    "fixed bottom-4 right-4 z-50 lg:hidden"
                )}
                onClick={handlePhoneClick}
            >
                {phoneNumber}
                <Icon name="phone-outgoing" />
            </Link>
        )
    }

    return null;
}